<div fxLayout="column" fxLayoutAlign="center center" fxFlex [class]="cssClass">
  <div fxFlex="1 1 auto"></div>

  <div class="icon" [class.svg-icon]="hasSvgIcon">
    <mat-icon *ngIf="hasSvgIcon; else defaultIcon" [svgIcon]="svgIcon"></mat-icon>
  </div>

  <div class="title">
    <span [innerHtml]="error | translate"></span>
  </div>

  <div class="description" *ngIf="isDescriptionAvailable">
    <span [innerHtml]="errorDescription | translate"></span>
  </div>

  <div class="details" *ngIf="errorDetails">
    {{ errorDetails | translate }}
  </div>

  <div *ngIf="showUpgradeButton">
    <a mat-raised-button color="primary" [routerLink]="billingRoute" class="upgrade-btn">{{ 'pricingLimit.upgradeBtn' |
      translate }}</a>
  </div>

  <div class="cta-buttons" *ngIf="isUnauthorized || isPageNotFound">
    <button mat-stroked-button color="primary" type="button" (click)="onBack()" class="upgrade-btn">{{ 'common.back' | translate | uppercase }}</button>
    <a mat-raised-button color="primary" [routerLink]="[dashboardRoute]" class="upgrade-btn">{{ 'common.goToDashboard' | translate | uppercase}}</a>
  </div>

  <div fxFlex="2 1 auto"></div>
</div>

<ng-template #defaultIcon>
  <mat-icon>{{icon}}</mat-icon>
</ng-template>
